

import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { getBanners } from '../asiosConfig';
import bannerBg from "../images/homebannerBG.png";
import bannerB from "../images/hero_banner_img.png";
import { toast } from 'react-toastify';
import { Skeleton } from '@mui/material';
import { FiMenu, FiX } from "react-icons/fi";

function Header({ scrollToForm }) {
  const [banners, setBanners] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [loginHover, setLoginHover] = useState(false);
  const [registerHover, setRegisterHover] = useState(false);

  const bannerIntervalRef = useRef(null);
  const headerRef = useRef(null);

  // Fetch banners
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await getBanners();
        if (response.status === 200 || response.status === 201) {
          setBanners(response.data || []);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
      } finally {
        setLoading(false);
      }
    };
    fetchBanner();
  }, []);

  // Banner slideshow
  useEffect(() => {
    if (banners.length > 0) {
      bannerIntervalRef.current = setInterval(() => {
        setActiveIndex((prev) => (prev + 1) % banners.length);
      }, 3000);
      return () => clearInterval(bannerIntervalRef.current);
    }
  }, [banners]);

  // Check mobile screen
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth <= 992);
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Scroll effect for fixed header
  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (headerRef.current) {
  //       if (window.scrollY > 0) headerRef.current.classList.add('scrolled');
  //       else headerRef.current.classList.remove('scrolled');
  //     }
  //   };
  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);


  // Scroll effect for fixed header
useEffect(() => {
  const handleScroll = () => {
    if (headerRef.current) {
      if (window.scrollY > 50) { // Change from 0 to 50 for better UX
        headerRef.current.classList.add('scrolled');
        headerRef.current.style.background = "linear-gradient(90deg, #fff8f0 0%, #fff4ef 100%)";
        headerRef.current.style.boxShadow = "0 2px 10px rgba(0, 0, 0, 0.05)";
      } else {
        headerRef.current.classList.remove('scrolled');
        headerRef.current.style.background = "transparent";
        headerRef.current.style.boxShadow = "none";
      }
    }
  };
  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, []);

  // Header/Nav styles (same as your Nav component)
  const styles = {

    navbar: {
  width: "100%",
  position: "fixed",
  top: 0,
  left: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: isMobile ? "16px 30px" : "8px 90px",
  background: "transparent", // Change from gradient to transparent
  zIndex: 100,
  fontFamily: "'Montserrat', sans-serif",
  fontSize: "15px",
  color: "#1f1f1f",
  transition: "all 0.3s ease", // Add smooth transition
  // Remove boxShadow initially
},


//     navbar: {
//   width: "100%",
//   position: "fixed",
//   top: 0,
//   left: 0,
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between", // Keep this
//   padding: isMobile ? "16px 30px" : "8px 90px",
//   background: "linear-gradient(90deg, #fff8f0 0%, #fff4ef 100%)",
//   zIndex: 100,
//   fontFamily: "'Montserrat', sans-serif",
//   fontSize: "15px",
//   color: "#1f1f1f",
//   boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
// },

    logo: { width: isMobile ? "180px" : "230px", objectFit: "contain" },
    // navLinks: { display: isMobile ? "none" : "flex", alignItems: "center", gap: "45px", flex: 1, color: "#2a2a2a" },

    navLinks: {
  display: isMobile ? "none" : "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "45px",
  flex: 1, // This makes it take available space and center properly
  fontWeight: 500,
  color: "#2a2a2a",
  position: "relative",
  // left: "50%", // Add this
  // transform: "translateX(-50%)", // Add this
},
    navItem: { textDecoration: "none", color: "#1f1f1f", fontWeight: 500, cursor: "pointer", transition: "color 0.3s ease" },
    rightButtons: { display: isMobile ? "none" : "flex", alignItems: "center", gap: "10px" },
    loginBtn: { borderRadius: "200px", backgroundColor: loginHover ? "rgba(51, 232, 138, 0.3)" : "rgba(217, 217, 217, 0.3)", border: "2px solid rgba(79, 79, 79, 0.2)", padding: "12px 28px", fontSize: "15px", color: "rgba(79, 79, 79, 0.8)", cursor: "pointer", transition: "all 0.3s ease" },
    registerBtn: { borderRadius: "100px", backgroundColor: registerHover ? "#ff3c3c" : "#ff6f61", border: "2px solid #ff3c3c", padding: "12px 34px", fontSize: "15px", color: "#fff", cursor: "pointer", transition: "all 0.3s ease" },
    menuIcon: { display: isMobile ? "block" : "none", cursor: "pointer", fontSize: "26px", color: "#1f1f1f" },
    mobileMenu: { display: menuOpen && isMobile ? "flex" : "none", flexDirection: "column", position: "absolute", top: "100%", left: 0, width: "100%", background: "#fff", padding: "20px", boxShadow: "0 4px 15px rgba(0,0,0,0.1)", zIndex: 99 },
    mobileNavLinks: { display: "flex", flexDirection: "column", gap: "15px", marginBottom: "20px", alignItems: "center" },
    mobileNavItem: { textDecoration: "none", color: "#1f1f1f", fontWeight: 500, fontSize: "16px", cursor: "pointer", transition: "color 0.3s ease" },
    mobileButtons: { display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" },
  };

  const handleButtonClick = () => {
    clearInterval(bannerIntervalRef.current);
    if (scrollToForm) scrollToForm();
    setMenuOpen(false);
  };

  return (
    <header>
      {/* Navbar */}
      <div style={styles.navbar} ref={headerRef}>
        <div>
        <Link to="/" style={{ textDecoration: "none" }}>
          <img src="images/ind-finallogo1.png" alt="IND Matrimony - Find Your Perfect Match" style={styles.logo} />
        </Link>
        </div>

        <div style={styles.navLinks}>
          <Link to="/about" style={styles.navItem}>About</Link>
          <Link to="/features" style={styles.navItem}>Feature</Link>
          <Link to="/success" style={styles.navItem}>Success Stories</Link>
          <Link to="/gallery" style={styles.navItem}>Gallery</Link>
        </div>

        <div style={styles.rightButtons}>
          <Link to="/otpLogin" style={{ textDecoration: "none", backgroundColor: "transparent"  }} onMouseEnter={() => setLoginHover(true)} onMouseLeave={() => setLoginHover(false)}>
            <div style={styles.loginBtn}>Login</div>
          </Link>
          <Link to="/register" style={{ textDecoration: "none", backgroundColor: "transparent"  }} onMouseEnter={() => setRegisterHover(true)} onMouseLeave={() => setRegisterHover(false)}>
            <div style={styles.registerBtn}>Register</div>
          </Link>
        </div>

        <div style={styles.menuIcon} onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FiX size={26} /> : <FiMenu size={26} />}
        </div>

        {/* Mobile Menu */}
        <div style={styles.mobileMenu}>
          <div style={styles.mobileNavLinks}>
            <Link to="/about" style={styles.mobileNavItem} onClick={() => setMenuOpen(false)}>About</Link>
            <Link to="/features" style={styles.mobileNavItem} onClick={() => setMenuOpen(false)}>Feature</Link>
            <Link to="/success" style={styles.mobileNavItem} onClick={() => setMenuOpen(false)}>Success Stories</Link>
            <Link to="/gallery" style={styles.mobileNavItem} onClick={() => setMenuOpen(false)}>Gallery</Link>
          </div>
          <div style={styles.mobileButtons}>
            <Link to="/otpLogin" style={{ textDecoration: "none" }} onClick={handleButtonClick}>
              <div style={styles.loginBtn}>Login</div>
            </Link>
            <Link to="/register" style={{ textDecoration: "none" }} onClick={handleButtonClick}>
              <div style={styles.registerBtn}>Register</div>
            </Link>
          </div>
        </div>
      </div>

      {/* Banner Section */}
      <div style={{ position: 'relative', height: '800px', overflow: 'hidden' }}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={800} animation="wave" sx={{ backgroundColor: '#e0e0e0' }} />
        ) : (
          banners.length > 0 ? banners.map((banner, index) => (
            <div
              key={index}
              style={{
                position: 'absolute',
                top: 0,
                left: `${index === activeIndex ? 0 : 100}%`,
                transition: 'left 1s ease-in-out',
                width: '100%',
                backgroundImage: `url(${banner.media_url || bannerBg})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: '800px',
              }}
            >
              <div className="container text-center" style={{ paddingTop: '250px' }}>
                <h1>{banner?.banner_text || 'Default Banner Text'}</h1>
                <p>{banner?.banner_description || 'Default description goes here'}</p>
                <Link to={banner?.cta_button_link || '/'} className="btn banBtn" onClick={handleButtonClick}>{banner?.cta_button_text || 'Register Now'}</Link>
              </div>
            </div>
          )) : (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                backgroundImage: `url(${bannerBg})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: '800px',
              }}
            >
              <div className="container text-center" style={{  }}>
                {/* all verified button */}
              </div>
              <div className="container text-center" style={{ paddingTop: '250px' }}>
                <h1>Jahaan dil milte hain, wahin se kahaniyaan shuru hoti hain</h1>
              </div>

              <div className="container">
                {/* hero image */}
              </div>




            </div>
          )
        )}
      </div>
    </header>
  );
}

export default Header;

